import { EvaluationChat } from "./evaluation_chat";

export class EvaluationChats extends Array<EvaluationChat> {
  constructor(evaluationChats?: EvaluationChat[]) {
    super();
    if (evaluationChats instanceof Array) {
      evaluationChats.forEach((evaluationChat) => this.push(evaluationChat));
    }
  }
}
